import {FetchStatus} from '../common/FetchStatus.enum';
import {PagewebLayoutState} from './PagewebLayoutState.interface';

/**
 * 주의 : mutable. immer 가 적용된 경우만 사용해야함
 */
export function initializeFetchStatus({
  state,
  id,
  isEnoughData,
  error,
}: {
  state: PagewebLayoutState;
  id: string;
  isEnoughData: boolean;
  error?: Error;
}) {
  if (error) {
    state.fetchStatus[id] = FetchStatus.Error;
    state.errors[id] = error;
    return;
  }

  if (!isEnoughData) {
    state.fetchStatus[id] = FetchStatus.Idle;
    return;
  }

  state.fetchStatus[id] = FetchStatus.Success;
}
